import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router';

const Page: React.FC<IPage> = ({ children, title }) => {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-6W3EMXG381', {
        page_path: location.pathname,
      });
    }
  }, [location.pathname]);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </>
  );
};

export default Page;

interface IPage {
  title: string;
  children: React.ReactNode;
}
